/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FlightSeatMap } from "./FlightSeatMap";
import {
  FlightSeatMapFromJSON,
  FlightSeatMapFromJSONTyped,
  FlightSeatMapToJSON,
  FlightSeatMapToJSONTyped,
} from "./FlightSeatMap";

/**
 *
 * @export
 * @interface FlightSeatMapsResponse
 */
export interface FlightSeatMapsResponse {
  /**
   *
   * @type {boolean}
   * @memberof FlightSeatMapsResponse
   */
  test: boolean;
  /**
   *
   * @type {string}
   * @memberof FlightSeatMapsResponse
   */
  provider: FlightSeatMapsResponseProviderEnum;
  /**
   *
   * @type {string}
   * @memberof FlightSeatMapsResponse
   */
  handoffId: string;
  /**
   *
   * @type {string}
   * @memberof FlightSeatMapsResponse
   */
  quoteId: string;
  /**
   *
   * @type {string}
   * @memberof FlightSeatMapsResponse
   */
  status: FlightSeatMapsResponseStatusEnum;
  /**
   *
   * @type {Array<FlightSeatMap>}
   * @memberof FlightSeatMapsResponse
   */
  maps: Array<FlightSeatMap>;
}

/**
 * @export
 */
export const FlightSeatMapsResponseProviderEnum = {
  Duffel: "duffel",
  Travelport: "travelport",
} as const;
export type FlightSeatMapsResponseProviderEnum =
  (typeof FlightSeatMapsResponseProviderEnum)[keyof typeof FlightSeatMapsResponseProviderEnum];

/**
 * @export
 */
export const FlightSeatMapsResponseStatusEnum = {
  Available: "available",
  Unavailable: "unavailable",
} as const;
export type FlightSeatMapsResponseStatusEnum =
  (typeof FlightSeatMapsResponseStatusEnum)[keyof typeof FlightSeatMapsResponseStatusEnum];

/**
 * Check if a given object implements the FlightSeatMapsResponse interface.
 */
export function instanceOfFlightSeatMapsResponse(
  value: object
): value is FlightSeatMapsResponse {
  if (!("test" in value) || value["test"] === undefined) return false;
  if (!("provider" in value) || value["provider"] === undefined) return false;
  if (!("handoffId" in value) || value["handoffId"] === undefined) return false;
  if (!("quoteId" in value) || value["quoteId"] === undefined) return false;
  if (!("status" in value) || value["status"] === undefined) return false;
  if (!("maps" in value) || value["maps"] === undefined) return false;
  return true;
}

export function FlightSeatMapsResponseFromJSON(
  json: any
): FlightSeatMapsResponse {
  return FlightSeatMapsResponseFromJSONTyped(json, false);
}

export function FlightSeatMapsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightSeatMapsResponse {
  if (json == null) {
    return json;
  }
  return {
    test: json["test"],
    provider: json["provider"],
    handoffId: json["handoff_id"],
    quoteId: json["quote_id"],
    status: json["status"],
    maps: (json["maps"] as Array<any>).map(FlightSeatMapFromJSON),
  };
}

export function FlightSeatMapsResponseToJSON(
  json: any
): FlightSeatMapsResponse {
  return FlightSeatMapsResponseToJSONTyped(json, false);
}

export function FlightSeatMapsResponseToJSONTyped(
  value?: FlightSeatMapsResponse | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    test: value["test"],
    provider: value["provider"],
    handoff_id: value["handoffId"],
    quote_id: value["quoteId"],
    status: value["status"],
    maps: (value["maps"] as Array<any>).map(FlightSeatMapToJSON),
  };
}
